import { Directive, OnDestroy, ElementRef, AfterViewInit, Renderer2, NgZone } from '@angular/core';
import { DatePickerComponent } from '@progress/kendo-angular-dateinputs';

@Directive({
  standalone: false,
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'kendo-datepicker',
})
export class CloseCalendarOnBlurDirective implements AfterViewInit, OnDestroy {
  private removeListener: () => void;

  constructor(
    private component: DatePickerComponent,
    private elementRef: ElementRef,
    private ngZone: NgZone,
    private renderer: Renderer2,
  ) {}

  ngAfterViewInit() {
    const input: HTMLElement = this.elementRef.nativeElement.querySelector('.k-input-inner');
    this.ngZone.runOutsideAngular(() => {
      this.removeListener = this.renderer.listen(input, 'focus', (e) => {
        if (e.relatedTarget?.classList.contains('k-calendar-table')) {
          this.component.toggle(false);
        }
      });
    });
  }

  ngOnDestroy() {
    this.removeListener();
  }
}
